// ==================== FeaturesSection.js ====================
import React from 'react';
import { User, Mail, Target, Calendar, Users, Sparkles } from 'lucide-react';

const FeaturesSection = ({ isVisible }) => {
  const features = [
    { icon: <User size={24} className="text-white" />, title: "LinkedIn Revamp", desc: "Fully redesign and rewrite your profile to stand out to recruiters", color: "from-cyan-400 to-blue-500" },
    { icon: <Mail size={24} className="text-white" />, title: "Resume Makeover", desc: "ATS-optimized, modern, and tailored to your industry", color: "from-purple-400 to-pink-500" },
    { icon: <Target size={24} className="text-white" />, title: "Job Applications", desc: "We apply to handpicked roles on your behalf, every week", color: "from-green-400 to-cyan-500" },
    { icon: <Calendar size={24} className="text-white" />, title: "Interview Setup", desc: "We schedule interviews and handle coordination", color: "from-orange-400 to-red-500" },
    { icon: <Users size={24} className="text-white" />, title: "Interview Coaching", desc: "Custom prep to help you feel confident and ready", color: "from-pink-400 to-purple-500" },
    { icon: <Sparkles size={24} className="text-white" />, title: "Regular Updates", desc: "Receive status reports and progress updates", color: "from-yellow-400 to-orange-500" }
  ];

  return (
    <section className="py-24" style={{ 
      background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 25%, #581c87 50%, #1e1b4b 75%, #0f172a 100%)',
      backgroundSize: '400% 400%',
      animation: 'gradientShift 15s ease infinite'
    }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl lg:text-6xl font-bold mb-6 text-white">
            What we do for you
          </h2>
          <p className="text-xl text-white/70 max-w-2xl mx-auto">
            Complete job search solution from profile to offer
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="relative overflow-hidden rounded-3xl p-8 transition-all duration-500 hover:scale-105 group"
              style={{
                background: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
                opacity: isVisible ? 1 : 0,
                transitionDelay: `${index * 100}ms`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
                e.currentTarget.style.borderColor = 'rgba(139, 92, 246, 0.3)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(139, 92, 246, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              {/* Gradient overlay on hover */}
              <div 
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                style={{
                  background: `linear-gradient(135deg, ${feature.color.split(' ')[1]} 0%, transparent 50%)`
                }}
              ></div>
              
              <div 
                className="w-16 h-16 rounded-2xl flex items-center justify-center mb-5 relative z-10"
                style={{
                  background: `linear-gradient(45deg, ${feature.color.split(' ')[1]}, ${feature.color.split(' ')[3]})`,
                  boxShadow: `0 8px 24px ${feature.color.split(' ')[1]}40`
                }}
              >
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3 text-white relative z-10">
                {feature.title}
              </h3>
              <p className="text-white/70 leading-relaxed relative z-10">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;